import { FilterOutlined, ReloadOutlined } from '@ant-design/icons'
import { Button, DatePicker } from 'antd'
import locale from 'antd/lib/date-picker/locale/es_ES'
import moment from 'moment'
import 'moment/locale/es'
import React from 'react'

moment.locale('es')

const FMT = 'YYYY-MM-DD'

export const toRange = ([a, b]) => ({ from: a.format(FMT), to: b.format(FMT) })

// Mes anterior completo: es el periodo de factura de Orange.
export const defaultRange = () =>
  toRange([
    moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month')
  ])

const PRESETS = () => ({
  'Mes anterior': [
    moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month')
  ],
  'Este mes': [moment().startOf('month'), moment()],
  'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
  'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
  'Este año': [moment().startOf('year'), moment()]
})

/**
 * Selector de periodo con atajos. El periodo elegido NO se aplica hasta pulsar
 * "Filtrar" (antes, cada cambio de fecha lanzaba una carga y los datos iban variando).
 */
const BillingFilters = ({ draft, applied, onDraft, onApply, loading }) => {
  const dirty = draft.from !== applied.from || draft.to !== applied.to
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
      <DatePicker.RangePicker
        locale={locale}
        format="DD/MM/YYYY"
        allowClear={false}
        ranges={PRESETS()}
        value={[moment(draft.from, FMT), moment(draft.to, FMT)]}
        disabledDate={(d) => d && d.isAfter(moment().endOf('day'))}
        onChange={(v) => v && v[0] && v[1] && onDraft(toRange(v))}
      />
      <Button
        type="primary"
        icon={dirty ? <FilterOutlined /> : <ReloadOutlined />}
        loading={loading}
        onClick={onApply}
      >
        {dirty ? 'Filtrar' : 'Recalcular'}
      </Button>
    </div>
  )
}

export default BillingFilters
